var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
/* istanbul ignore file */ // TODO Byro add unit tests once confirmed this isn't in need of new design
import { getPaletteColor } from 'pcln-design-system';
import React, { useCallback, useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { usePennySubscriber, BroadcastType } from '../utils/pennyBroadcast';
import StopIcon from '../svgs/StopIcon';
var CIRCLE_OPACITY = 0.3;
var ROTATION_DURATION = 5; // How long it takes for the entire circle container to rotate 360 degrees
var TRAVEL_DURATION = 5; // How long it takes for the circle to travel in a complete triangle
var CIRCLE_TRAVEL_DURATION = 6; // Circle Travel Distance in pixels from origin to points of triangles
var Circle = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "RecordingIndicator__Circle",
  componentId: "sc-18yqdzm-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: 50%;\n  position: absolute;\n  background: ", ";\n  width: 161px;\n  height: 161px;\n"], ["\n  border-radius: 50%;\n  position: absolute;\n  background: ", ";\n  width: 161px;\n  height: 161px;\n"])), function (props) {
  return props.color || 'transparent';
});
var CircleContainer = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "RecordingIndicator__CircleContainer",
  componentId: "sc-18yqdzm-1"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  transform-origin: ", ";\n  top: -80px;\n  left: -80px;\n"], ["\n  position: relative;\n  transform-origin: ", ";\n  top: -80px;\n  left: -80px;\n"])), function (props) {
  return "".concat(props.originX, "px ").concat(props.originY, "px");
});
var actionTextVariants = {
  open: {
    opacity: 1,
    translateY: 6,
    transition: {
      duration: 0.3
    }
  },
  closed: {
    opacity: 0,
    translateY: 135,
    transition: {
      duration: 0.3
    }
  }
};
var ActionText = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "RecordingIndicator__ActionText",
  componentId: "sc-18yqdzm-2"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  line-height: 20px;\n  z-index: 1000;\n  color: ", ";\n  opacity: 0;\n  svg {\n    margin-right: 6px;\n  }\n"], ["\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  line-height: 20px;\n  z-index: 1000;\n  color: ", ";\n  opacity: 0;\n  svg {\n    margin-right: 6px;\n  }\n"])), function (props) {
  return "".concat(getPaletteColor('text.lightest')(props));
});
var overlayVariants = {
  open: {
    borderRadius: '0px',
    height: '290px',
    bounce: 0,
    transition: {
      ease: [0.25, 0.1, 0.25, 1.0]
    },
    originX: 1,
    originY: 0,
    opacity: 0.98
  },
  closed: {
    borderRadius: '0%',
    transition: {
      ease: [0.25, 0.1, 0.25, 1.0]
    },
    height: '0px',
    originX: 1,
    originY: 0,
    opacity: 0
  }
};
var Overlay = /*#__PURE__*/styled(motion.div).withConfig({
  displayName: "RecordingIndicator__Overlay",
  componentId: "sc-18yqdzm-3"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  bottom: 0;\n  cursor: pointer;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  background: linear-gradient(135deg, #9654cd 40%, #6f78e5 80%);\n"], ["\n  bottom: 0;\n  cursor: pointer;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  background: linear-gradient(135deg, #9654cd 40%, #6f78e5 80%);\n"])));
var RecordingIndicator = function (_a) {
  var isRecording = _a.isRecording,
    onClose = _a.onClose,
    _b = _a.originX,
    originX = _b === void 0 ? 80 : _b,
    _c = _a.originY,
    originY = _c === void 0 ? 80 : _c,
    _d = _a.rotationDuration,
    rotationDuration = _d === void 0 ? ROTATION_DURATION : _d,
    _e = _a.travelDuration,
    travelDuration = _e === void 0 ? TRAVEL_DURATION : _e,
    _f = _a.circleTravelDistance,
    circleTravelDistance = _f === void 0 ? CIRCLE_TRAVEL_DURATION : _f,
    _g = _a.circleOpacity,
    circleOpacity = _g === void 0 ? CIRCLE_OPACITY : _g;
  var circleTransition = {
    type: 'spring',
    bounce: 1,
    duration: travelDuration,
    repeat: Infinity
  };
  var circleContainerVariants = {
    open: {
      rotate: 360,
      transition: {
        repeat: Infinity,
        duration: rotationDuration,
        ease: 'linear'
      }
    }
  };
  var _h = useState(isRecording),
    showOverlay = _h[0],
    setShowOverlay = _h[1];
  var pennyBroadcastListener = useCallback(function (event) {
    if (event.data.type === BroadcastType.VOICE_RECORDING_STARTED) {
      setShowOverlay(true);
    } else if (event.data.type === BroadcastType.VOICE_RECORDING_STOPPED) {
      setShowOverlay(false);
    }
  }, []);
  usePennySubscriber(pennyBroadcastListener);
  useEffect(function () {
    setShowOverlay(isRecording);
  }, [isRecording]);
  return React.createElement(React.Fragment, null, React.createElement(Overlay, {
    animate: showOverlay ? 'open' : 'closed',
    initial: {
      height: 0,
      overflow: 'hidden'
    },
    variants: overlayVariants,
    onClick: onClose
  }, React.createElement(ActionText, {
    animate: showOverlay ? 'open' : 'closed',
    variants: actionTextVariants
  }, React.createElement(StopIcon, null), "Finish speaking to send"), React.createElement(CircleContainer, {
    originX: originX,
    originY: originY,
    animate: showOverlay ? 'open' : 'closed',
    variants: circleContainerVariants
  }, React.createElement(Circle, {
    key: 'animated-circle-1',
    initial: {
      y: -circleTravelDistance,
      opacity: circleOpacity
    },
    animate: {
      x: [0, circleTravelDistance, -circleTravelDistance, 0],
      y: [-circleTravelDistance, circleTravelDistance, circleTravelDistance, -circleTravelDistance]
    },
    transition: circleTransition,
    color: '#7701BB'
  }), React.createElement(Circle, {
    key: 'animated-circle-2',
    initial: {
      y: circleTravelDistance,
      x: circleTravelDistance,
      opacity: circleOpacity
    },
    animate: {
      x: [circleTravelDistance, -circleTravelDistance, 0, circleTravelDistance],
      y: [circleTravelDistance, circleTravelDistance, -circleTravelDistance, circleTravelDistance]
    },
    transition: circleTransition,
    color: '#BB01B4'
  }), React.createElement(Circle, {
    key: 'animated-circle-3',
    initial: {
      x: -circleTravelDistance,
      y: circleTravelDistance,
      opacity: circleOpacity
    },
    animate: {
      x: [-circleTravelDistance, 0, circleTravelDistance, -circleTravelDistance],
      y: [circleTravelDistance, -circleTravelDistance, circleTravelDistance, circleTravelDistance]
    },
    transition: circleTransition,
    color: '#0068EF'
  }))));
};
export default RecordingIndicator;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;